import React from 'react';
import { withStyles, Grid, Typography, CircularProgress } from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { withTranslation } from 'react-i18next';
import highchartsXrange from 'highcharts/modules/xrange';
import highchartsTimeline from 'highcharts/modules/timeline';
import * as ActionColors from '../../../../themes/summaryReportColor';

highchartsXrange(Highcharts);
highchartsTimeline(Highcharts);
class ActivityDetails extends React.PureComponent {
  getAlertSerieData(alerts) {
    const { t } = this.props;
    let name = ' ';
    switch (alerts.name) {
      case 'Getup':
        name = `${t('get_up')}`;
        break;
      case 'Movement':
        name = `${t('movement')}`;
        break;
      case 'Not Turn':
        name = `${t('alert_not_turn')}`;
        break;
      case 'No Movement For':
        name = `${t('alert_no_movement')}`;
        break;
      case 'Fall':
        name = `${t('alert_fall')}`;
        break;
      case 'Exit':
        name = `${t('alert_exit')}`;
        break;
      case 'Get Near':
        name = `${t('alert_near')}`;
        break;
      case 'Walking':
        name = `${t('alert_walking')}`;
        break;
      case 'Emergency':
        name = `${t('alert_emergency_alarm')}`;
        break;
      default:
        break;
    }
    return name;
  }

  getMovementChart(movementData) {
    const { t } = this.props;
    const dataMovement = {
      chart: {
        type: 'area',
        plotBorderWidth: 1.5,
        height: 135,
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'movement');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
        // visible: false
      },
      yAxis: {
        title: {
          text: `${t('graph_title_activity_index')}`,
          align: 'middle',
          rotation: 0,
          offset: 50,
          textAlign: 'right',
          useHTML: true,
          style: {
            fontSize: '11px',
          },
          x: localStorage.getItem('i18nextLng') === 'th-TH' ? -30 : -10,
        },
        max: 10,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        labels: {
          format: ' ',
          // enabled: false,
          useHTML: true,
          style: {
            minWidth: '120px',
          },
        },
      },
      tooltip: {
        headerFormat:
          '<span style="color:{point.color}">●</span> <span style="font-size: 10px"> {point.x:%H:%M:%S}</span><br/>',
        pointFormat: `${t('graph_title_activity_index')} : {point.y}`,
      },
      plotOptions: {
        area: {
          lineWidth: 0,
          marker: {
            enabled: false,
          },
          step: 'right',
        },
        series: {
          marker: {
            lineWidth: 0,
            enabled: false,
          },
          showInLegend: false,
          step: 'right',
        },
        line: {
          lineWidth: 0,
          marker: {
            enabled: false,
          },
        },
      },
      colors: ['#85929E'],
      series: [
        {
          name: '',
          data: movementData,
          step: true,
          tooltip: {
            valueDecimals: 2,
          },
        },
      ],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              plotOptions: {
                series: {
                  marker: {
                    radius: 2.5,
                  },
                },
              },
            },
          },
        ],
      },
    };

    return (
      <Typography component='div' style={{ width: '100%', paddingTop: '10px', paddingBottom: 20 }}>
        <HighchartsReact highcharts={Highcharts} options={dataMovement} callback={this.props.dataChartMovement} />
        <p
          style={{
            textAlign: 'center',
            color: 'rgb(171, 166, 166)',
            fontSize: 14,
            marginBottom: 10,
          }}
        >
          Click and drag in the plot area to zoom in
        </p>
      </Typography>
    );
  }

  getAlertChart(alerts) {
    const { t } = this.props;
    let dataAlert = {};
    let serieData = alerts.map((val) => {
      val.name = this.getAlertSerieData(val);
      if (val.data.length > 0) {
        val.data.map((data) => {
          data.name = this.getAlertSerieData(data);
          return data;
        });
      }
      return val;
    });

    if (localStorage.getItem('role_id') === '1') {
      dataAlert = {
        credits: {
          enabled: false,
        },
        chart: {
          plotBorderWidth: 1.5,
          type: 'scatter',
          height: '150px',
          zoomType: 'x',
          resetZoomButton: {
            theme: {
              display: 'none',
            },
          },
          events: {
            selection: (event) => {
              if (event.originalEvent) {
                this.props.syncZoom(event, 'warning');
              }
            },
          },
        },
        plotOptions: {
          series: {
            lineWidth: 0,
          },
          timeline: {
            dataLabels: false,
          },
          line: {
            dataLabels: true,
          },
        },
        xAxis: {
          type: 'datetime',
          visible: false,
          maxWidth: '500px',
        },
        yAxis: {
          gridLineColor: '#cccccc',
          title: {
            text: `${t('graph_title_alert')}`,
            align: 'middle',
            rotation: 0,
            offset: localStorage.getItem('i18nextLng') === 'th-TH' ? 95 : 102,
            textAlign: 'right',
            useHTML: true,
            style: {
              fontSize: '11px',
            },
          },
          reversed: true,
          labels: {
            format: ' ',
            useHTML: true,
            style: {
              minWidth: '50px',
            },
          },
          gridLineWidth: 1,
        },
        legend: {
          align: 'left',
          verticalAlign: 'top',
          layout: 'horizontal',
          x: 250,
          y: 0,
        },
        title: {
          text: '',
        },
        tooltip: {
          headerFormat:
            '<span style="color:{point.color}">●</span> <span style="font-size: 10px"> {point.x:%H:%M:%S}</span><br/>',
          pointFormat: `<span>${t(
            'alert_type',
          )}: </span><span style="color:{point.color}; font-weight: bold;">{point.name}</span>`,
        },
        // tooltip: {
        //   headerFormat:
        //     '<span style="color:{point.color}">●</span> <span style="font-size: 10px"> {point.x:%A, %b %d, %H:%M:%S}</span><br/>',
        //   pointFormat: `<span>${t(
        //     "alert_type"
        //   )}: </span><span style="color:{point.color}; font-weight: bold;">{point.name}</span>`,
        // },
        series: serieData,
      };
    }
    return (
      <Typography component='div' style={{ width: '100%', paddingTop: '10px' }}>
        {localStorage.getItem('role_id') === '1' && (
          <HighchartsReact highcharts={Highcharts} options={dataAlert} callback={this.props.dataChartAlert} />
        )}
      </Typography>
    );
  }

  getActivityChart(activityData) {
    const { t } = this.props;
    const dataAcvitity = {
      chart: {
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        plotBorderWidth: 1.5,
        type: 'xrange',
        height: 200,
        zoomType: 'x',
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'activity');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
        visible: false,
      },
      yAxis: {
        gridLineColor: '#cccccc',
        title: {
          text: '',
        },
        categories: [
          `${t('walking')}`,
          `${t('standing')}`,
          `${t('sitting')}`,
          `${t('lying_on_right_side')}`,
          `${t('lying_on_left_side')}`,
          `${t('lying_on_back')}`,
          `${t('lying_on_stomach')}`,
          `${t('unknown')}`,
        ],
        reversed: true,
        labels: {
          useHTML: true,
          style: {
            minWidth: '120px',
          },
        },
      },
      plotOptions: {
        series: {
          showInLegend: false,
        },
      },
      colors: [
        ActionColors.COLOR_WALKING,
        ActionColors.COLOR_STANDING,
        ActionColors.COLOR_SITTING,
        ActionColors.COLOR_LYING_ON_RIGHT_SIDE,
        ActionColors.COLOR_LYING_ON_LEFT_SIDE,
        ActionColors.COLOR_LYING_ON_BACK,
        ActionColors.COLOR_LYING_ON_STOMACH,
      ],

      series: [
        {
          name: ' ',
          // borderColor: "gray",
          pointWidth: 20,
          data: activityData,
          dataLabels: {
            enabled: true,
          },
          turboThreshold: 0,
        },
      ],
      tooltip: {
        headerFormat: '<span style="font-size: 10px"> {point.x:%H:%M:%S } - {point.x2:%H:%M:%S }</span><br/>',
        pointFormat: `<span style="color:{point.color}">● </span> <b>{point.yCategory}</b><br/><span>${t(
          'location',
        )} : {point.loc}</span>`,
      },
    };

    return (
      <Typography component='div' style={{ width: '100%', paddingTop: '10px' }}>
        <HighchartsReact highcharts={Highcharts} options={dataAcvitity} callback={this.props.dataChartAction} />
      </Typography>
    );
  }

  render() {
    const { t, classes } = this.props;
    const { chartData, movementData, alerts, checkingTodayData, hasDataToday, alertsHasData, loadingActivity } =
      this.props.summary.toJS();
    // const alertsHasData = (alerts || []).filter(a => a.data.length > 0);
    console.log('chartData: ', chartData);

    return (
      <div className='flex-wrap flex-auto w-screen bg-gradient-to-b from-primary-gradient to-transparent'>
        <Grid container>
          <div className='flex-wrap w-full pt-3 mx-auto px-19 md:flex'>
            {this.props.zoom && (
              <div className='flex-wrap w-full pt-1 mx-auto pb-7 md:flex h-25 space-5'>
                <div className='relative items-end justify-end flex-grow text-right'>
                  <button
                    className='bottom-0 right-0 h-10 px-5 text-sm font-bold text-gray-600 border border-gray-300 rounded-lg bg-button-download '
                    onClick={this.props.resetZoom}
                  >
                    {t('reset_zoom')}
                  </button>
                </div>
              </div>
            )}
            {!checkingTodayData ? (
              !loadingActivity ? (
                <div className='w-full max-h-screen bg-white rounded md:box-content'>
                  <Grid container>
                    {hasDataToday && (chartData.length > 9 || alertsHasData.length > 1) ? (
                      <Grid container>
                        <Typography component='div' style={{ width: '100%', paddingTop: '10px' }}>
                          {this.getAlertChart(alerts)}
                          {this.getActivityChart(chartData)}
                          {this.getMovementChart(movementData)}
                        </Typography>
                      </Grid>
                    ) : (
                      <Grid container>
                        <Typography component='div' className={classes.noDataBox}>
                          {' '}
                          {t('no_data')}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </div>
              ) : (
                <div className='flex justify-center w-full text-center'>
                  <div className='flex mt-4'>
                    <CircularProgress size={26} />
                    <div className='px-5 pt-0.5  text-base text-gray-600'>{t('loading')}</div>
                  </div>
                </div>
              )
            ) : (
              ''
            )}
          </div>
        </Grid>
      </div>
    );
  }
}

const styles = (theme) => ({
  noDataBox: {
    padding: 8 * 3,
    fontSize: 16,
    fontFamily: 'kanit',
    fontWeight: 600,
    color: theme.palette.text.header,
  },
});

export const page = inject('summary')(observer(ActivityDetails));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
